import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { CustomRestBackend } from './customRestBackend';

const NAMESPACES = ['menu', 'alerts', 'commons', 'components'];

function parseMissingKeyHandler(key: string) {
  // return the key itself, which is the French text, when missing
  return key;
}

i18n
  .use(initReactI18next)
  .use(
    new CustomRestBackend(undefined, {
      endpoint: '/api/translations/translations/',
    })
  )
  .init({
    fallbackLng: false, // no fall back language, the key itself is the fallback
    returnEmptyString: false,
    ns: NAMESPACES,
    defaultNS: NAMESPACES[0],
    debug: false,
    interpolation: { escapeValue: false },
    react: { useSuspense: true },
    returnNull: false,
    parseMissingKeyHandler,
    keySeparator: false,
    nsSeparator: false,
    load: 'currentOnly', // no attempt to load the language code without the country code, as the API will not handle it
  });

export default i18n;
